<template>
  <b-modal
    :id="modalId"
    hide-footer
    hide-header
    centered
    content-class="pendency-modal"
  >
    <div class="pendency-header">
      <h3>{{ title }}</h3>
    </div>
    <div class="pendency-divider"></div>
    <div class="pendency-body">
      <p>{{ content }}</p>
    </div>
    <div class="pendency-footer">
      <b-button @click="close">{{ buttonText }}</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PendencyModal",
  props: {
    modalId: {
      type: String,
      default: "modal-evidence",
    },
    title: {
      type: String,
      default: "Pendência",
    },
    content: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "Fechar",
    },
  },
  methods: {
    close() {
      this.$bvModal.hide(this.modalId);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.pendency-modal {
  border-radius: 8px;
  overflow: hidden;
}

.pendency-header {
  padding: 15px 20px 0;

  h3 {
    color: #36b67d;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    margin: 0;
  }
}

.pendency-divider {
  height: 1px;
  background-color: #e6e6e6;
  margin: 15px 0;
  position: relative;

  &:after,
  &:before {
    content: none !important;
  }
}

.pendency-body {
  padding: 0 20px;
  min-height: 100px;
  max-height: 60vh;
  overflow-y: auto;

  p {
    font-size: 16px;
    line-height: 1.5;
    color: #4f4f4f;
  }
}

.pendency-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;

  button {
    background-color: #36b67d;
    border-color: #36b67d;
    color: white;
    font-weight: 500;
    padding: 8px 20px;
    border-radius: 4px;

    &:hover {
      background-color: darken(#36b67d, 7%);
      border-color: darken(#36b67d, 7%);
    }
  }
}
</style>
